import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@shared/hooks/useAuth';
import LoadingIndicator from '@shared/ui/common/LoadingIndicator';
import { useTutorialStore } from '../../application/store/TutorialStore';

/**
 * Sends users to the home dashboard, or to onboarding when unlock-dashboard
 * has not been completed yet (company preference).
 */
const DashboardLandingRedirect: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const unlockDashboardCompleted = useTutorialStore((s) => s.unlockDashboardCompleted);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  // Auth must be checked before company-hydrated prefs — logout resets
  // unlockDashboardCompleted to null, which would otherwise hang forever.
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  if (unlockDashboardCompleted === null) {
    return <LoadingIndicator />;
  }

  if (!unlockDashboardCompleted) {
    return <Navigate to="/dashboard/onboarding" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default DashboardLandingRedirect;
